import { atom, PrimitiveAtom } from 'jotai';

import {
    DMConversationMessage,
    MessageFilter,
    SocialInboxMessage
} from '@/components/pages/conversations/SocialInbox/types';

import { DEFAULT_SELECTED_MESSAGES } from '@/components/pages/conversations/SocialInbox/const';

/** ID of the message that is viewed in the chat section of the social inbox. */
export const openedMessageAtom = atom<SocialInboxMessage>(
    null
) as PrimitiveAtom<SocialInboxMessage>;

/** IDs of the selected messages in the social inbox. */
export const selectedMessagesAtom =
    atom<typeof DEFAULT_SELECTED_MESSAGES>(DEFAULT_SELECTED_MESSAGES);

/** Message that is being replied to in the social inbox. */
export const replyMessageAtom = atom<DMConversationMessage>(
    null
) as PrimitiveAtom<DMConversationMessage>;

/** Selected secondary filter in the social inbox. */
export const messageFilterSecondaryAtom = atom<MessageFilter>({
    search: '',
    filter: 'all',
    sort: 'desc'
});

export const conversationParticipantProfilePicturesAtom = atom<Record<string, string>>(
    {}
) as PrimitiveAtom<Record<string, string>>;
